import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { CurriculumSessionService } from 'src/app/services/curriculum-session.service';
import { HeaderComponent } from 'src/app/shared/header/header.component';
import { LoaderComponent } from 'src/app/shared/loader/loader.component';
import { ListPaginatorModule } from 'src/app/shared/list/list-paginator/list-paginator.module';

@Component({
  selector: 'app-curriculum-sessions-list',
  templateUrl: './curriculum-sessions-list.component.html',
  styleUrls: ['./curriculum-sessions-list.component.scss'],
  imports: [CommonModule, HeaderComponent, LoaderComponent, ListPaginatorModule],
})
export class CurriculumSessionsListComponent implements OnInit {
  private router = inject(Router);
  private sessionService = inject(CurriculumSessionService);

  sessions: any[] = [];
  loading = false;
  filter: 'all' | 'unreviewed' | 'approved' = 'all';
  searchTerm = '';
  unreviewedCount = 0;
  currentPage = 1;
  totalPages = 1;

  ngOnInit(): void {
    this.loadList();
    this.loadUnreviewedCount();
  }

  loadList(): void {
    this.loading = true;
    const params: any = { text: this.searchTerm || undefined, page: this.currentPage };
    if (this.filter === 'approved') {
      params.clinicalApproved = true;
    }
    if (this.filter === 'unreviewed') {
      params.clinicalApproved = false;
    }

    this.sessionService.list(params).subscribe(response => {
      this.sessions = response.sessions;
      this.totalPages = response.totalPages;
      this.loading = false;
    });
  }

  onPageChange(newPage: number): void {
    this.currentPage = newPage;
    this.loadList();
  }

  loadUnreviewedCount(): void {
    this.sessionService.list({ clinicalApproved: false }).subscribe(response => {
      this.unreviewedCount = response.total;
    });
  }

  setFilter(f: 'all' | 'unreviewed' | 'approved'): void {
    this.filter = f;
    this.currentPage = 1;
    this.loadList();
  }

  onSearch(term: string): void {
    this.searchTerm = term;
    this.currentPage = 1;
    this.loadList();
  }

  goToReview(): void {
    this.router.navigate(['/curriculum-sessions/review']);
  }

  goToNew(): void {
    this.router.navigate(['/curriculum-sessions/new']);
  }

  goToEdit(uuid: string): void {
    this.router.navigate(['/curriculum-sessions', uuid]);
  }

  confirmDelete(session: any): void {
    if (!confirm(`Delete session #${session.sessionOrder} from "${session.unitTitle}"?`)) {
      return;
    }
    this.sessionService.delete(session.sessionId).subscribe(() => {
      this.loadList();
      this.loadUnreviewedCount();
    });
  }
}
